import { BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XL, BREAKPOINT_XS, BREAKPOINT_XXL } from './constants';

const defaultThemeConfigurations = {
  breakpoints: {
    values: {
      xs: BREAKPOINT_XS,
      sm: BREAKPOINT_SM,
      md: BREAKPOINT_MD,
      lg: BREAKPOINT_LG,
      xl: BREAKPOINT_XL,
      xxl: BREAKPOINT_XXL,
    },
  },
  typography: {
    fontSize: 12,
    button: {
      textTransform: 'none',
      width: 'auto',
      height: 'auto',
    },
  },
};

export default defaultThemeConfigurations;
